import { Box } from '@ktag/styleguide/dist/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  currentElectionYear: number;
  isBiproportional?: boolean;
}

const NationalCouncilExemptionBox = ({
  currentElectionYear,
  isBiproportional,
}: Props) => {
  const { t } = useTranslation('wap');

  // show info box only on the 2023 national council election (NRW), to explain merger of two parties
  const showNationalCouncilExemption = currentElectionYear === 2023 && !isBiproportional;

  if (!showNationalCouncilExemption) {
    return null;
  }

  return (
    <Box
      type="information"
      heading={t('national_council_exemption_title')}
      additionalClassNames="nationalcouncil__exemption-box"
    >
      {t('national_council_exemption_text')}
    </Box>
  );
};

export default NationalCouncilExemptionBox;
